import React from 'react'
import { useAuth } from '../../context/AuthContext'
import { Link, NavLink } from 'react-router-dom'
import { Home,  Label, ManageAccounts, MoreVert, Settings} from '@mui/icons-material';
import { useAppData } from '../../context/AppDataContext';
import DefaultClinicComponent from './DefaultClinicComponent';
import JoinRequest from './JoinRequest';




function AppHeader() {

    const {authUser } = useAuth();
    const {associateProfile } = useAppData();
   

    return (
        <>
        
        {/* <nav className="navbar navbar-expand-lg navbar-dark bg-white  sticky-top shadow mb-3"> */}
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark  sticky-top shadow mb-3">
            <div className="container-fluid">
                <Link className="me-2" to="/"><img src='/images/ghospital-logo.png' style={{height:40}} /></Link> {/* navbar-brand  */}
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="collapsibleNavbar">
                    { authUser.role <= 2 && 
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0" style={{fontSize:"18px"}}>
                        <li className="nav-item"><NavLink className="nav-link text-center" to="/"> <Home/> Home</NavLink></li>
                        {/* Dropdown ref 
                        <li className="nav-item dropdown">
                            <NavLink className="nav-link dropdown-toggle" to="/report" role="button" data-bs-toggle="dropdown"><ListAlt/>Report</NavLink>
                            <ul className="dropdown-menu">
                                <li><NavLink className="dropdown-item" to="/report/token-report">Token Report</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/report/feedback-report">Feedback Report</NavLink></li>
                            </ul>
                        </li>
                        */}
                        
                    </ul>
                    }
                    {/* Just for Alignment  */}
                    <div className=" me-auto ">
                        <DefaultClinicComponent/>
                    </div>
                    {/* Just for Alignment  */}
                    <ul className="navbar-nav">
                        {/*
                        <li className="nav-item dropdown">
                            <a className="nav-link" href="!#" id="adminControllDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> <MoreVert/> </a>
                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="adminControllDropdown">
                                <li><NavLink className="dropdown-item" to="/master/list"><Label /> Status Master</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/user/list"><ManageAccounts/> Manage User Accounts</NavLink></li>
                                <li><NavLink className="dropdown-item" to="/user/role"><Settings/> Manage User Role</NavLink></li>
                            </ul>
                        </li>
                        */}
                        <li className='nav-item text-white my-1 mx-3'><JoinRequest/></li>
                        {associateProfile &&
                        <li className="nav-item dropdown">
                            <a className="btn btn-info" style={{borderRadius:"50px"}} href="!#" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false"> 
                                { isNaN(associateProfile.firstName) ?
                                    associateProfile.firstName.charAt(0).toUpperCase()
                                    :
                                    associateProfile.firstName
                                }
                            </a>
                            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                                <li><NavLink className="dropdown-item" to="/profile">My Profile</NavLink></li>
                                <li><hr className="dropdown-divider"/></li>
                                <li><NavLink className="dropdown-item" to="/auth/logout">Logout</NavLink></li>
                            </ul>
                        </li>
                        }
                    </ul>
                </div>
            </div>
        </nav>
        </>
    )
}

export default AppHeader